import React from "react";
import { Switch } from "react-router-dom";
import Route from "./Route";
import LoginPage from "../components/pages/LoginPage/LoginPage";
import HomePage from "../components/pages/HomePage/HomePage";
import ProductsPage from "../components/pages/ProductsPage/ProductsPage";
import StockPage from "../components/pages/StockPage/StockPage";
import ProviderPage from "../components/pages/ProviderPage/ProviderPage";
import UsersPage from "../components/pages/UsersPage/UsersPage";
import BalanceSheet from "../components/pages/BalanceSheet/BalanceSheet";

const Routes = () => (
    <>
        <Switch>
            <Route path="/" exact component={LoginPage} />
            <Route path="/dashboard" requiresAuth exact component={HomePage} />
            <Route
                path="/products"
                requiresAuth
                exact
                component={ProductsPage}
            />
            <Route
              path="/stock"
              requiresAuth
              exact
              component={StockPage}
            />
            <Route
              path="/provider"
              requiresAuth
              exact
              component={ProviderPage}
            />
          <Route
            path="/balance"
            requiresAuth
            exact
            component={BalanceSheet}
          />
          <Route
            path="/users"
            requiresAuth
            exact
            component={UsersPage}
          />
        </Switch>
    </>
);

export default Routes;
